import { DynamicDecorator } from '../../DynamicDecorator/DynamicDecorator';
import { Gradient } from '../../Gradient/Gradient';

export const ErrorDecorator = () => (
  <>
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute left-9 top-[calc(50%-170px)] hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute left-0 top-[calc(50%-110px)] hidden h-9 w-9 rotate-[-90deg] md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute right-12 top-[calc(50%-40px)] hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute right-0 top-[calc(50%-170px)] hidden h-6 w-6 md:block"
    />
    <Gradient
      variant="grayBlob"
      className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]"
    />
  </>
);
